import * as React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import Nav from "./nav";
import Footer from "../admin/footer";
import axios from 'axios';
import { useState, useEffect } from "react";
import { Padding } from '@mui/icons-material';


export default function Dashboard() {
  const [list,setList]=useState([])
  const [list_risponse,setlist_risponse]=useState([])

  const [data,setData]=useState([])

  const [user,setUser]=useState(null);

    
        const text_th = {
          color: 'Black',
          fontSize: '14px',
         
        };
        const text_td = {
          color: 'orange',
          fontSize: '14px',
          fontWeight: 'bold',
          width: 'fit-content'
         
        };
    
    
  const getInq = async (inquiry_id,team_id)=> {
    const data = new FormData();
    data.append('inquiry_id',inquiry_id);

            axios({
              method: 'post',
              url: '/api_lock/admin/inq_view_byid.php',
              data: data,
              headers: {'Content-Type': 'multipart/form-data'},
            })
              .then(s => {

                
 const arry=s.data;
 if(arry=="[]")
 {
  console.log("null")
 }else{
  setList(s.data)
                console.log("s_data_phone",s.data)
                //getphone(s.data[0].phone)
                response_list(inquiry_id)

 }


               })
              .catch(s => {
                console.log('here catch =>>', s);
              });
          };

  const get_all_status = async (inquiry_id)=> {
    const data = new FormData();
    data.append('inquiry_id',inquiry_id);
  
            axios({
              method: 'post',
              url: '/api_lock/admin/view_inq_status_team_agent.php',
              data: data,
              headers: {'Content-Type': 'multipart/form-data'},
            })
              .then(s => {
                //setlist_risponse(s.data)

                console.log(s.data)
                console.log("get_all_status")
                setData(s.data)

               
         
              })
              .catch(s => {
                console.log('here catch =>>', s);
              });
          };

  const response_list = async (inquiry_id)=> {
    const data = new FormData();
    data.append('inquiry_id',inquiry_id);
  
            axios({
              method: 'post',
              url: '/api_lock/manager/view_response_id.php',
              data: data,
              headers: {'Content-Type': 'multipart/form-data'},
            })
              .then(s => {
                setlist_risponse(s.data)

                console.log(s.data)
                get_all_status(inquiry_id)
                manager_response_list(inquiry_id)
               
         
              })
              .catch(s => {
                console.log('here catch =>>', s);
              });
          };


       
            
          const [status_list,setStatusList]=useState([])
          const getStatus = async ()=> {
            const data = new FormData();
            data.append('inquiry_id','');
         
                    axios({
                      method: 'post',
                      url: '/api_lock/status/list.php',
                      data: data,
                      headers: {'Content-Type': 'multipart/form-data'},
                    })
                      .then(s => {
                       
        
                         console.log(s.data)
                         setStatusList(s.data)
                       
                        
                      
                 
                      })
                      .catch(s => {
                        console.log('here catch =>>', s);
                      });
                  };
        
                             // Function to get names by value
                             const getNamesByValue = (array, value) => {
                              return array
                                .filter(item => item.value === value)
                                .map(item => item.name);
                            };

  useEffect(() => {
    getStatus();
    //fetchData()
    
    const queryParams = new URLSearchParams(window.location.search)
    const id = queryParams.get("id")
    if(id==null || id=='')
    {
      window.location.replace("/login")
    }

   


    const a=localStorage.getItem("Admin");
    if(a==null)
    {
      window.location.replace("/login")
    }else{
      setUser(a)
      getInq(id,JSON.parse(a)[0].team);
     
    }



  }, []);


  const [manager_list_risponse,setManagerlist_risponse]=useState([])
  const manager_response_list = async (inquiry_id)=> {
    const data = new FormData();
    data.append('inquiry_id',inquiry_id);
  
            axios({
              method: 'post',
              url: '/api_lock/manager/manager_view_response_id.php',
              data: data,
              headers: {'Content-Type': 'multipart/form-data'},
            })
              .then(s => {
                setManagerlist_risponse(s.data)

                console.log(" setManagerlist_risponse ",s.data)
               
         
              })
              .catch(s => {
                console.log('here catch =>>', s);
              });
          };





  return (
  <>

  <Nav />



    <div className="page-container" style={{backgroundColor:"#F9FBFD"}}>
        {/* Content Wrapper START */}
        <div className="main-content">
            <div className='row'>
        
          
            <div className='col-5'>
            <div className="card">
  
  
   <div className="card-body">
 <div>
      <div >
      
        <div className="row">
          <div >
          
      {
        list.map((v)=>(   
        

            <div >
                
            <h1>Received Inquiry</h1>
            
            
         <div className='row'>
            <div className='col-6' style={text_th} >Inquiry ID</div>
            <div className='col-6' style={text_td}>{v.id}</div>
          
            </div>
         <div className='row'>
       
            <div className='col-6' style={text_th} >Web</div>
            <div className='col-6' style={text_td}>{v.web}</div>
            </div>

         <div className='row'>
            <div className='col-6' style={text_th} >Inquiry Date</div>
            <div className='col-6' style={text_td}>{v.date_portal} {v.date_time}</div>
          
            </div>
         <div className='row'>
       
            <div className='col-6' style={text_th} >Inquiry Received</div>
            <div className='col-6' style={text_td}>{v.sender}</div>
            </div>

         <div className='row'>
            <div className='col-6' style={text_th} >Name</div>
            <div className='col-6' style={text_td}>{v.name}</div>

            </div>
         <div className='row'>
   
            <div className='col-6' style={text_th} >Email</div>
            <div className='col-6' style={text_td}>{v.email}</div>
            </div>

         <div className='row'>
            <div className='col-6' style={text_th} >Phone </div>
            <div className='col-6' style={text_td}>{v.phone}</div>
          
            {/* <div className='col-6' style={text_th} >Departure</div>
            <div className='col-6' style={text_td}>{v.dep}</div> */}
            </div>
         <div className='row'>
            {/* <div className='col-6' style={text_th} >Arrival</div>
            <div className='col-6' style={text_td}> {v.arri}</div> */}
            <div className='col-6' style={text_th} >Qualification</div>
            <div className='col-6' style={text_td}>{v.date}</div>
            </div>
         <div className='row'>
            <div className='col-6' style={text_th} >Study Course</div>
            <div className='col-6' style={text_td}>{v.makkah}</div>
            <div className='col-6' style={text_th} >Country</div>
            <div className='col-6' style={text_td}>{v.madina}</div>
            </div>
         <div className='row'>
            {/* <div className='col-6' style={text_th} >Rooms</div>
            <div className='col-6' style={text_td}>{v.rooms}</div>
            <div className='col-6' style={text_th} >Accommodation</div>
            <div className='col-6' style={text_td}>{v.acc}</div> */}
            <div className='col-6' style={text_th} >Type</div>
            <div className='col-6' style={text_td}>{v.type}</div>
            <div className='col-6' style={text_th} >Url</div>
            <div className='col-6' style={text_td}><a href={v.url}>Click</a> </div>
            </div>

         <div className='row'>
           
         {/* view_response_id.php */}
            {
                v.duration==""?<></>:<> <div className='col-6' style={text_th} >Duration</div>
                <div className='col-3' style={text_td}>{v.duration}</div></>
            }
           
            </div>

            <div >
     
     <div className="row">
       <div >
       
   {
     data.map((v)=>(   
     

         <div >
             <br/>
         <h3>Details</h3>
         
         {
          data[0].msg=="agent"?<>
          <div className='row'>
         <div className='col-6' style={text_th} >Team name k</div>
         <div className='col-6' style={text_td}>{v.tname}</div>
         </div>
          <div className='row'>
         <div className='col-6' style={text_th} >Agent Name</div>
         <div className='col-6' style={text_td}>{v.uname}</div>
         </div>
         <br/>

         
          
         </>:<></>
         }

    
  

    
       </div>
    
        
        

   ))
   }
     
       </div>
     </div>
     
   </div>
          </div>
       
           
           

      ))
      }
        
          </div>
        </div>
        
      </div>
    </div>
  
  </div>
 
      
    
    </div>
            </div>
            
        </div>

  

<div>
{
  manager_list_risponse.length>0?<>
  <div class="table-responsive">
    <h2>History Manager</h2>
    <table class="table">
        <thead>
            <tr>
                <th scope="col">#</th>
                <th scope="col">Status</th>
                <th scope="col">Msg</th>
                <th scope="col">Date & Time</th>
                <th scope="col">Type</th>
            </tr>
        </thead>
        <tbody>
            {
              manager_list_risponse.map((v,ii)=>(
                <tr>
                <th scope="row">{v.i}</th>
                <td>{v.s=="Reminder"?<> {getNamesByValue(status_list,v.s)} ({v.date}) </>:getNamesByValue(status_list,v.s)}</td>
                <td>{v.msg}</td>
                <td>{v.date} {v.at}</td>
                <td>{v.type=="true"?"Incorrect":"correct"}</td>
                
            </tr>
              ))
            }
            
        </tbody>
    </table>
</div>
</>:<></>
}  
  
    <div class="table-responsive">
    
    <h2>Agent History</h2>
    <table class="table">
    
        <thead>
            <tr>
                <th scope="col">#</th>
                <th scope="col">Status</th>
                <th scope="col">Msg</th>
                <th scope="col">At</th>
            </tr>
        </thead>
        <tbody>
          
            {
              list_risponse.map((v,ii)=>(
                <tr>
                <th scope="row">{v.i}</th>
                <td>{v.s=="Reminder"?<> {getNamesByValue(status_list,v.s)}({v.date}) </>:getNamesByValue(status_list,v.s)}</td>
                <td>{v.msg}</td>
                <td>{v.at}</td>
            </tr>
              ))
            }
            
        </tbody>
    </table>
</div>



</div>



        </div>
        {/* Content Wrapper END */}
        {/* Footer START */}
<Footer />
        {/* Footer END */}
      </div>
      
  </>
  );
}